import '../index.css';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Card from 'react-bootstrap/Card';
import Signup from './Signup';
import InfoModal from './InfoModal';
import BWModal from './BWModal';
import MealModal from './MealModal';
import WorkoutModal from './WorkoutModal';

function Plans() {

    return (
        <div className='plans' >
            <h1 className='planHeader shadow' style={{backgroundColor:"black"}}> Coaching Plans</h1>
            
            <Row className='fluid m-5 position-relative' style={{justifyContent:"center"}}>
                
                    <Card className='shadow m-2' style={{ maxWidth:"20rem", backgroundColor:'black', justifyContent:"center", overflow:"auto", color:'white', border:'2px solid', borderColor:'#D33D3D'}}>
                                <Card.Img variant='top' className='img-fluid mb-5 mt-1 rounded' src="img/CompPlan.webp" />
                                <Card.Body >
                                    <Card.Title >
                                        Comprehensive Fitness Coaching
                                    </Card.Title>
                                    <>
                                        <Row>
                                            <Col>
                                                <InfoModal />
                                            </Col>
                                            <Col>
                                                <Signup name={"Comprehensive Fitness Coaching Subscription"} placement={"end"} pack={"https://v3portal.ptdistinction.com/package_signup?apk=JT3BLCKMUU1832908&pkid=42138&embed=1"} />
                                            </Col>
                                        </Row>
                                    </>
                                </Card.Body>
                    </Card>
                
                    <Card className='shadow m-2' style={{ maxWidth:"20rem", backgroundColor:'black', justifyContent:"center", overflow:"auto", color:'white', border:'2px solid', borderColor:'#D33D3D'}}>
                                <Card.Img variant='top' className='img-fluid mb-5 mt-1 rounded' src="img/bloodwork.webp" style={{width:"auto", height:"auto"}} />
                                <Card.Body > 
                                    <Card.Title>
                                        Blood Work Lab & Interpretation
                                    </Card.Title>
                                    <>
                                        <Row>
                                            <Col>
                                                <BWModal />
                                            </Col>
                                            <Col>
                                                <Signup name={"Blood Work Lab Builder & Interpretation"} placement={"end"} pack={"https://v3portal.ptdistinction.com/package_signup?apk=JT3BLCKMUU1832908&pkid=42494&embed=1"} />
                                            </Col>
                                        </Row>
                                    </>
                                </Card.Body>  
                    </Card>
                
                    <Card className='shadow m-2' style={{ maxWidth:"20rem", backgroundColor:'black', justifyContent:"center", overflow:"auto", color:'white', border:'2px solid', borderColor:'#D33D3D'}}>
                                <Card.Img variant='top' className='img-fluid mb-5 mt-1 rounded' src="img/mealplan.webp" style={{width:"auto", height:"auto"}} />
                                <Card.Body >
                                    <Card.Title >
                                        One Time Meal Plan One Month
                                    </Card.Title>
                                    <>
                                        <Row>
                                            <Col>
                                                <MealModal />
                                            </Col>
                                            <Col>
                                                <Signup name={"One Time Meal Plan One Month"} placement={"end"} pack={"https://v3portal.ptdistinction.com/package_signup?apk=JT3BLCKMUU1832908&pkid=42362&embed=1"} />
                                            </Col>
                                        </Row>
                                    </>
                                </Card.Body>
                    </Card>
                
                    <Card className='shadow m-2' style={{ maxWidth:"20rem", backgroundColor:'black', justifyContent:"center", overflow:"auto", color:'white', border:'2px solid', borderColor:'#D33D3D'}}>
                        <Card.Img variant='top' className='img-fluid mb-5 mt-1 rounded' src="img\workoutplan.webp" style={{width:"auto", height:"auto"}} />
                            <Card.Body >
                                <Card.Title >
                                    One Time Workout Regimen One Month
                                </Card.Title>
                                <>
                                    <Row>
                                        <Col>
                                            <WorkoutModal />
                                        </Col>
                                        <Col>
                                            <Signup name={"One Time Workout Regimen One Month"} placement={"end"} pack={"https://v3portal.ptdistinction.com/package_signup?apk=JT3BLCKMUU1832908&pkid=42363&embed=1"} />
                                        </Col>
                                    </Row>
                                </>
                            </Card.Body> 
                    </Card>
                

            </Row>
            
            
        </div>
        
    );
}

export default Plans;